import { atom } from 'jotai';
export const $SearchParams = atom(new URLSearchParams());
$SearchParams.debugLabel = '$SearchParams';
export const $Location = atom({});
$Location.debugLabel = '$Location';
